import type { MCQChoice } from './schema';

/** EAA-2030: single-choice key — the chosen option becomes the only correct one. */
export function selectSingleCorrect(choices: MCQChoice[], id: string): MCQChoice[] {
    return choices.map((c) => ({ ...c, isCorrect: c.id === id }));
}

/** EAA-2030: leaving multiple-correct mode keeps only the first key. */
export function keepFirstCorrect(choices: MCQChoice[]): MCQChoice[] {
    const firstKey = choices.find((c) => c.isCorrect)?.id;
    return choices.map((c) => ({ ...c, isCorrect: c.id === firstKey }));
}
